// Module
var code = "<template>\n  <div if.bind=\"recyclingCompany\"> \n    <div class=\"form-element\">\n      <label for=\"name\" t=\"general.name\"></label>\n      <input type=\"text\" name=\"name\" value.bind=\"recyclingCompany.Name\">\n    </div>\n</template>";
// Exports
export default code;